import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/star.svg";
var StarSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  StarSolid_default as default
};
